import {PageManager} from 'genesis-packages/core';
import './CPCD.scss';

export default class CPCD extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

};
